var _rect, _rect2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.2 0 12.4 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 1.875,
    width: 11.25,
    height: 0.75,
    rx: 0.375,
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 7.875,
    width: 11.25,
    height: 0.75,
    rx: 0.375,
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 2.25,
    r: 1.75,
    fill: "#fff",
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8.25,
    r: 1.75,
    fill: "#fff",
    stroke: "currentColor"
  })));
};
export default SvgFilter;